import { Frame, Ratio, TShirtSize } from "../../types/product";

// square frames
// small
import blackSquareSmallWebp from "../../assets/images/frames/black.square.small.webp";
import whiteSquareSmallWebp from "../../assets/images/frames/white.square.small.webp";
import naturalSquareSmallWebp from "../../assets/images/frames/natural.square.small.webp";
// import brownSquareSmallWebp from "../../assets/images/frames/brown.square.small.webp";

// medium
import blackSquareMediumWebp from "../../assets/images/frames/black.square.medium.webp";
import whiteSquareMediumWebp from "../../assets/images/frames/white.square.medium.webp";
import naturalSquareMediumWebp from "../../assets/images/frames/natural.square.medium.webp";
// import brownSquareMediumWebp from "../../assets/images/frames/brown.square.medium.webp";

// large
import blackSquareLargeWebp from "../../assets/images/frames/black.square.large.webp";
import whiteSquareLargeWebp from "../../assets/images/frames/white.square.large.webp";
import naturalSquareLargeWebp from "../../assets/images/frames/natural.square.large.webp";
// import brownSquareLargeWebp from "../../assets/images/frames/brown.square.large.webp";

// x large
import blackSquareXLargeWebp from "../../assets/images/frames/black.square.xlarge.webp";
import whiteSquareXLargeWebp from "../../assets/images/frames/white.square.xlarge.webp";
import naturalSquareXLargeWebp from "../../assets/images/frames/natural.square.xlarge.webp";
// import brownSquareXLargeWebp from "../../assets/images/frames/brown.square.xlarge.webp";

// rectangle frames
// portrait
// small
import blackRectangleSmallWebp from "../../assets/images/frames/black.rectangle.small.webp";
import whiteRectangleSmallWebp from "../../assets/images/frames/white.rectangle.small.webp";
import naturalRectangleSmallWebp from "../../assets/images/frames/natural.rectangle.small.webp";
// import brownRectangleSmall from "../../assets/images/frames/brown.rectangle.small.png";
// import brownRectangleSmallWebp from "../../assets/images/frames/brown.rectangle.small.webp";

// medium
import blackRectangleMediumWebp from "../../assets/images/frames/black.rectangle.medium.webp";
import whiteRectangleMediumWebp from "../../assets/images/frames/white.rectangle.medium.webp";
import naturalRectangleMediumWebp from "../../assets/images/frames/natural.rectangle.medium.webp";
// import brownRectangleMedium from "../../assets/images/frames/brown.rectangle.medium.png";
// import brownRectangleMediumWebp from "../../assets/images/frames/brown.rectangle.medium.webp";

// large
import blackRectangleLargeWebp from "../../assets/images/frames/black.rectangle.large.webp";
import whiteRectangleLargeWebp from "../../assets/images/frames/white.rectangle.large.webp";
import naturalRectangleLargeWebp from "../../assets/images/frames/natural.rectangle.large.webp";
// import brownRectangleLargeWebp from "../../assets/images/frames/brown.rectangle.large.webp";

// x large
import blackRectangleXLargeWebp from "../../assets/images/frames/black.rectangle.xlarge.webp";
import whiteRectangleXLargeWebp from "../../assets/images/frames/white.rectangle.xlarge.webp";
import naturalRectangleXLargeWebp from "../../assets/images/frames/natural.rectangle.xlarge.webp";
// import brownRectangleXLargeWebp from "../../assets/images/frames/brown.rectangle.xlarge.webp";

// landscape
// small
import blackRectangleSmallLandscapeWebp from "../../assets/images/frames/black.rectangle.small.landscape.webp";
import whiteRectangleSmallLandscapeWebp from "../../assets/images/frames/white.rectangle.small.landscape.webp";
import naturalRectangleSmallLandscapeWebp from "../../assets/images/frames/natural.rectangle.small.landscape.webp";
// import brownRectangleSmallLandscapeWebp from "../../assets/images/frames/brown.rectangle.small.landscape.webp";

// medium
import blackRectangleMediumLandscapeWebp from "../../assets/images/frames/black.rectangle.medium.landscape.webp";
import whiteRectangleMediumLandscapeWebp from "../../assets/images/frames/white.rectangle.medium.landscape.webp";
import naturalRectangleMediumLandscapeWebp from "../../assets/images/frames/natural.rectangle.medium.landscape.webp";
// import brownRectangleMediumLandscapeWebp from "../../assets/images/frames/brown.rectangle.medium.landscape.webp";

// large
import blackRectangleLargeLandscapeWebp from "../../assets/images/frames/black.rectangle.large.landscape.webp";
import whiteRectangleLargeLandscapeWebp from "../../assets/images/frames/white.rectangle.large.landscape.webp";
import naturalRectangleLargeLandscapeWebp from "../../assets/images/frames/natural.rectangle.large.landscape.webp";
// import brownRectangleLargeLandscapeWebp from "../../assets/images/frames/brown.rectangle.large.landscape.webp";

// x large
import blackRectangleXLargeLandscapeWebp from "../../assets/images/frames/black.rectangle.xlarge.landscape.webp";
import whiteRectangleXLargeLandscapeWebp from "../../assets/images/frames/white.rectangle.xlarge.landscape.webp";
import naturalRectangleXLargeLandscapeWebp from "../../assets/images/frames/natural.rectangle.xlarge.landscape.webp";
// import brownRectangleXLargeLandscapeWebp from "../../assets/images/frames/brown.rectangle.xlarge.landscape.webp";

// canvas
import canvasblacklandscape from "../../assets/images/frames/canvasblacklandscape.webp";
import canvasnaturallandscape from "../../assets/images/frames/canvasnaturallandscape.webp";
import canvaswhitelandscape from "../../assets/images/frames/canvaswhitelandscape.webp";
import canvasblackportrait from "../../assets/images/frames/canvasblackportrait.webp";
import canvasnaturalportrait from "../../assets/images/frames/canvasnaturalportrait.webp";
import canvaswhiteportrait from "../../assets/images/frames/canvaswhiteportrait.webp";
import canvasblacksquare from "../../assets/images/frames/canvasblacksquare.webp";
import canvasnaturalsquare from "../../assets/images/frames/canvasnaturalsquare.webp";
import canvaswhitesquare from "../../assets/images/frames/canvaswhitesquare.webp";

type FrameColor = "natural" | "black" | "white";

const frameImages: {
  [key in FrameColor]: {
    [key in Ratio]: {
      [key in TShirtSize]: string;
    };
  };
} = {
  [Frame.Natural]: {
    [Ratio.Square]: {
      [TShirtSize.Small]: naturalSquareSmallWebp,
      [TShirtSize.Medium]: naturalSquareMediumWebp,
      [TShirtSize.Large]: naturalSquareLargeWebp,
      [TShirtSize.XLarge]: naturalSquareXLargeWebp,
    },
    [Ratio.Rectangle]: {
      [TShirtSize.Small]: naturalRectangleSmallWebp,
      [TShirtSize.Medium]: naturalRectangleMediumWebp,
      [TShirtSize.Large]: naturalRectangleLargeWebp,
      [TShirtSize.XLarge]: naturalRectangleXLargeWebp,
    },
  },
  [Frame.Black]: {
    [Ratio.Square]: {
      [TShirtSize.Small]: blackSquareSmallWebp,
      [TShirtSize.Medium]: blackSquareMediumWebp,
      [TShirtSize.Large]: blackSquareLargeWebp,
      [TShirtSize.XLarge]: blackSquareXLargeWebp,
    },
    [Ratio.Rectangle]: {
      [TShirtSize.Small]: blackRectangleSmallWebp,
      [TShirtSize.Medium]: blackRectangleMediumWebp,
      [TShirtSize.Large]: blackRectangleLargeWebp,
      [TShirtSize.XLarge]: blackRectangleXLargeWebp,
    },
  },
  [Frame.White]: {
    [Ratio.Square]: {
      [TShirtSize.Small]: whiteSquareSmallWebp,
      [TShirtSize.Medium]: whiteSquareMediumWebp,
      [TShirtSize.Large]: whiteSquareLargeWebp,
      [TShirtSize.XLarge]: whiteSquareXLargeWebp,
    },
    [Ratio.Rectangle]: {
      [TShirtSize.Small]: whiteRectangleSmallWebp,
      [TShirtSize.Medium]: whiteRectangleMediumWebp,
      [TShirtSize.Large]: whiteRectangleLargeWebp,
      [TShirtSize.XLarge]: whiteRectangleXLargeWebp,
    },
  },
};

const landscapeFrameImages: {
  [key in FrameColor]: {
    [key in TShirtSize]: string;
  };
} = {
  [Frame.Natural]: {
    [TShirtSize.Small]: naturalRectangleSmallLandscapeWebp,
    [TShirtSize.Medium]: naturalRectangleMediumLandscapeWebp,
    [TShirtSize.Large]: naturalRectangleLargeLandscapeWebp,
    [TShirtSize.XLarge]: naturalRectangleXLargeLandscapeWebp,
  },
  [Frame.Black]: {
    [TShirtSize.Small]: blackRectangleSmallLandscapeWebp,
    [TShirtSize.Medium]: blackRectangleMediumLandscapeWebp,
    [TShirtSize.Large]: blackRectangleLargeLandscapeWebp,
    [TShirtSize.XLarge]: blackRectangleXLargeLandscapeWebp,
  },
  [Frame.White]: {
    [TShirtSize.Small]: whiteRectangleSmallLandscapeWebp,
    [TShirtSize.Medium]: whiteRectangleMediumLandscapeWebp,
    [TShirtSize.Large]: whiteRectangleLargeLandscapeWebp,
    [TShirtSize.XLarge]: whiteRectangleXLargeLandscapeWebp,
  },
};

const canvasFrameImages: {
  [key in FrameColor]: {
    [key in "portrait" | "landscape" | "square"]: string;
  };
} = {
  [Frame.Natural]: {
    portrait: canvasnaturalportrait,
    landscape: canvasnaturallandscape,
    square: canvasnaturalsquare,
  },
  [Frame.Black]: {
    portrait: canvasblackportrait,
    landscape: canvasblacklandscape,
    square: canvasblacksquare,
  },
  [Frame.White]: {
    portrait: canvaswhiteportrait,
    landscape: canvaswhitelandscape,
    square: canvaswhitesquare,
  },
};

export const getFrameImages = (ratio: Ratio, frame: Frame, size: TShirtSize, isLandscape: boolean, canvas: boolean) => {
  if (canvas) {
    const canvasColorImages = frame === "unframed" ? canvasFrameImages.natural : canvasFrameImages[frame];
    const canvasRatio = isLandscape ? "landscape" : ratio === Ratio.Square ? "square" : "portrait";
    return canvasColorImages[canvasRatio];
  }

  if (isLandscape) {
    const landscapeColorImages = frame === "unframed" ? landscapeFrameImages.natural : landscapeFrameImages[frame];
    return landscapeColorImages[size];
  }

  const colorFrameImages = frame === Frame.Unframed ? frameImages.natural : frameImages[frame];
  return colorFrameImages[ratio][size];
};
